import type {
  Command,
  Dependencias,
} from '@/features/proposta/entities/Comprador/form-to-listagem/comprador-listagem-command-factory'
import type { TClientePessoaFisicaPropostaSchema, TCompradorPropostaSchema } from '@/features/proposta/schemas'
import type { CompradorVinculoStepSchemaInput } from '@/features/proposta/schemas/compradores/comprador-pf.schema'

export class AtualizarCompradorComNovoRepresentanteLegalCommand implements Command {
  constructor(
    private readonly clientesPF: () => TClientePessoaFisicaPropostaSchema[],
    private readonly compradores: () => TCompradorPropostaSchema[],
    private readonly deps: Dependencias,
    private readonly vinculo: CompradorVinculoStepSchemaInput,
  ) {}

  executar() {
    const clientes = this.clientesPF()
    const compradores = this.compradores()
    const indexCliente = clientes.findIndex((cliente) => cliente.id === this.vinculo.dados.id!)
    const clienteJaCadastrado = indexCliente !== -1

    const cliente: TClientePessoaFisicaPropostaSchema = {
      id: this.vinculo.dados.id!,
      nome: this.vinculo.dados.nome,
      cpf: this.vinculo.dados.cpf,
      maiorDe18Anos: true,
      nacionalidadeId: this.vinculo.dados.nacionalidadeId,
      profissaoId: this.vinculo.dados.profissaoId,
      tipoDoCliente: 'Contato',
      email: this.vinculo.contato.email!,
      telefone: {
        numero: this.vinculo.contato.telefone!.numero.replaceAll(/\D/g, ''),
        origem: this.vinculo.contato.telefone!.origem!,
        principal: true,
      },
      imagem: this.vinculo.imagem,
      estadoCivil: this.vinculo.estadoCivil?.status,
      possuiUniaoEstavel: this.vinculo.estadoCivil?.uniaoEstavel
        ? this.vinculo.estadoCivil?.uniaoEstavel === 'sim'
        : null,
      regimeCasamento: this.vinculo.estadoCivil?.regimeCasamento ?? null,
    }

    if (!clienteJaCadastrado) {
      this.deps.adicionarCliente(cliente)
    } else {
      this.deps.atualizarCliente(indexCliente, cliente)
    }

    this.vinculo.compradorVinculadoIds.forEach((compradorId) => {
      const compradorIndex = compradores.findIndex((c) => c.clienteId === compradorId)
      if (compradorIndex !== -1) {
        const compradorAtualizado = {
          ...compradores[compradorIndex]!,
          vinculos: [
            ...compradores[compradorIndex]!.vinculos.filter((vinculo) => vinculo.clienteId !== this.vinculo.dados.id!),
            {
              clienteId: this.vinculo.dados.id!,
              tipo: 'Representante' as const,
            },
          ],
        }
        this.deps.atualizarComprador(compradorIndex, compradorAtualizado)
      }
    })
  }
}
